import React from 'react'
import { Field, reduxForm } from 'redux-form'
import styles from './Forms.css'
import TextInput from '../../containers/Forms/components/TextInput'
import Loading from '../../components/Loading'
import ValidationRules from '../../components/ValidationRules'
import { requiredValidation } from '../../containers/Forms/components/formValidations'

const UpdatePasswordForm = props => {
  const {
    handleSubmit,
    handleInputChange,
    validationTests,
    invalid,
    pristine,
    isSubmitting,
    submitting,
    pwError,
    pwErrorMsg,
    onInfoSubmit,
  } = props

  return (
    <form onSubmit={handleSubmit}>
      <div className={styles.formSection}>
        <div className={styles.formSectionRowStacked}>
          <Field
            component={TextInput}
            name="currentPassword"
            label="Current password"
            type="password"
            showRedRequiredIcon={true}
            validate={requiredValidation}
            onChange={handleInputChange}
          />
          <Field
            component={TextInput}
            name="newPassword"
            label="New password"
            type="password"
            showRedRequiredIcon={true}
            validate={requiredValidation}
            onChange={handleInputChange}
          />
          <Field
            component={TextInput}
            name="newPasswordConfirm"
            label="Confirm new password"
            type="password"
            showRedRequiredIcon={true}
            validate={requiredValidation}
            onChange={handleInputChange}
          />
        </div>
      </div>
      <div className={styles.validationRules}>
        <ValidationRules validationTests={validationTests} updatePassword={true}/>
      </div>
      {pwError && <div className={styles.pwValidationError}>{pwErrorMsg}</div>}
      <div className={styles.updatePwWrapper}>
        <div className={styles.buttonWrapper}>
          {submitting || isSubmitting ? (
            <button disabled className={styles.submitLoading}>
              <Loading />
            </button>
          ) : (
            <button type="submit" disabled={invalid || pristine} className={styles.submit}>
              Save
            </button>
          )}
        </div>
      </div>
    </form >
  )
}

export default reduxForm({
  form: 'updatePasswordForm',
  enableReinitialize: true,
})(UpdatePasswordForm)



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/UpdatePasswordForm.jsx